import { useLayoutEffect, useEffect, useState, useContext } from "react";
import { PieChart, Pie, Cell } from "recharts";
import { useTranslation } from "react-i18next";
import { UiContext } from "../../../context/UiContext";

export function MinuteGraphicPie({
  heading,
  lastAudience,
  dataPie,
  heightPie,
}) {
  const [widthPage, setWidthPage] = useState(window.innerWidth);

  const {
    isMobile,
    hasShortHeightDetail,
    hasShortHeight } = useContext(UiContext);

  function updateWidth() {
    setWidthPage(window.innerWidth);
  }

  window.addEventListener("resize", updateWidth);
  useLayoutEffect(() => { }, []);

  useEffect(() => { }, [widthPage]);
  const getChartLineHeight = () => {
    if (hasShortHeightDetail) {
      if (window.innerHeight <= 320) {
        return 0;
      }
      if (window.innerHeight <= 400) {
        return 200;
      }
    }
    return 263;
  };
  const calcWidthForPie = () => {
    return window.innerWidth / 2 - 180 + 5;
  }
  const { t } = useTranslation();

  const chartHeight = getChartLineHeight();
  let firstHeader = document.getElementsByClassName("headerFirst")[0];
  let firstHeaderWidth = parseFloat(firstHeader !== undefined ? getComputedStyle(firstHeader).width : '0');

  let GridAudienceColumn = document.getElementsByClassName("cellRows").length > 0 ? document.getElementsByClassName("cellRows")[0] : document.getElementsByClassName("tableFirstGridWhite")[0];
  let audienceColumnWidth = parseFloat(GridAudienceColumn !== undefined ? getComputedStyle(GridAudienceColumn).width : '0');
  const contentGraphic = (
    <div style={{ width: "100%", display: "block" }}>
      <div style={{
        height: chartHeight + "px",
        display: 'table',
        marginLeft: calcWidthForPie() + "px",
      }}>
        <PieChart className="chartPie" width={180} height={chartHeight} >
          <Pie
            data={dataPie?.map((item) => ({ ...item, value: (item.value === 100 || item.value === 0) ? 0 : item.value }))}
            dataKey="value"
            nameKey="name"
            outerRadius={heightPie}
            stroke="0"
          >
            {dataPie?.map((head, headID) => (
              <Cell
                key={`cell-${head?.value}`}
                fill={heading !== undefined ? heading.enabled[headID]?.color : "rgb(255,255,255)"}
              />
            ))}
          </Pie>
        </PieChart>
      </div>
      <p className="infoPie" style={{
        display: hasShortHeight ? "none" : "block",
      }}>{t("chart.pieChartLabel")}</p>
      <div
        id="tableGraphicPie"
        style={{
          overflow: "hidden",
          marginRight: "1%",
          position: "relative",
          width: "100%",
        }}
      >
        <table>
          <tbody>
            <td
              className="tdHead"
              style={{
                verticalAlign: "bottom",
                padding: "0px",
                height: `10px`,
                width: `${Math.round(firstHeaderWidth)}px`,
                position: "relative",
                minWidth: `${Math.round(firstHeaderWidth)}px`,
              }}
            ></td>
            {heading?.enabled?.map((head, headID) => (
              <td
                key={"tdMinuteGraphicPie" + head.id}
                style={{
                  verticalAlign: "bottom",
                  padding: "0px",
                  height: `10px`,
                  position: "relative",
                  width: `${audienceColumnWidth}px`,
                }}
              >
                <div
                  className="tableGraphic"
                  style={{
                    backgroundColor: head.color,
                    height: "10px",
                    position: "relative",
                    width: `${audienceColumnWidth - 2}px`,
                  }}
                ></div>
              </td>
            ))}
          </tbody>
        </table>
      </div>
    </div >
  );
  return (
    <div id="pieChart" data-testid="pieChart">
      {contentGraphic}
    </div>
  );
}

